import React, { useEffect, useRef  } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchAllOrders } from "../../redux/actions/orderActions"
import { CustomDataTable } from "../../components"
import { RiEdit2Line, RiDeleteBin6Line, RiEyeLine, RiDownloadLine } from "react-icons/ri"
import { Link, useNavigate } from "react-router-dom"
import { BASE_URL, IMG } from "../../constant"
import { BiDotsVerticalRounded, BiCopy } from 'react-icons/bi'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import copy from 'copy-to-clipboard'
import { toast } from "react-toastify"
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import HiddenPO from "./HiddenPO"


const Orders = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.admin);
  const { orders, loader, errors } = useSelector((state) => state.orders);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      dispatch(fetchAllOrders({ token }));
    }
  }, [dispatch, token]);

  const handleView = (id, number) => {
    navigate(`/order/${number.toLowerCase()}/${id}/view`)
  };
  const handleEdit2 = (id, number) => {
    navigate(`/order/${number.toLowerCase()}/${id}/edit`)
  };
  const handleEdit = (id, number) => {
    const url = `/order/${number.toLowerCase()}/${id}/edit`;
    window.open(url, '_blank'); // '_blank' opens in a new tab
  };
  const handleDelete = (id) => console.log("Delete Customer:", id);

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined date
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(/ (\d{4})$/, ", $1"); // Adds a comma before the year
  };

  
  const formattedDate = (dateString) => {
    // Format date: Sun, Apr 6, 2025
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    console.log("FormattedDate", createdAt)
    return createdAt.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  const formattedTime = (dateString) => {
    // Format time: 06:33 PM
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    return createdAt.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  const handleCopy = (link) => {
      const success = copy(link); // Returns true if copied
      if (success) {
        toast.info('Copied!');
      }
  };

  const refs = useRef({});

  const downloadInvoice = async (orderId) => {
    const element = refs.current[orderId];
    const canvas = await html2canvas(element, { scale: 3, useCORS: true });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.setFont('times');
    pdf.setFontSize(36);
    pdf.save(`${orderId}-invoice.pdf`);
  };
  

  const columns = [
    {
      name: "Customer",
      selector: (row) => {
        try {
          const address = JSON.parse(row.address); // Convert JSON string to an object
          return (
            <div className="dprofile">
              <img src={IMG.DP} alt="dp" />
              <div className="items">
                <span className="name fw-600">{`${address.fname} ${address.lname}`}</span>
                <span className="email text-neutral-dark-200 fs-xs">{`${row.email}`}</span>
                <span className="phone text-neutral-dark-200 fs-xs">{`${address.phone}`}</span>
              </div>
            </div>
          );
        } catch (error) {
          return "Invalid Address"; // Handle JSON parsing errors
        }
      },
       width: "250px"
    },
    {
      name: <span className="cellHeading">Order ID</span>,
      selector: (row) => {
        const warning = ['Processing', 'On hold'].includes(row.status); // .warBtn
        const success = ['Dispatched', 'Partial Dispatch', 'Completed'].includes(row.status); // onlineBtn
        const error = ['RTO', 'Canceled'].includes(row.status); // codBtn
        const info = ['Waiting for goods'].includes(row.status); // infBtn

        // Decide which class & label to show
        let className = '';
        if (warning) className = 'warBtn';
        else if (success) className = 'onlineBtn';
        else if (error)   className = 'codBtn';
        else if (info)    className = 'infBtn';
        
        return (
          <>
            <div>
              <span className="fw-500">{row.po_number}</span> <br/>
              <small className="text-neutral-dark-200 fs-xs">{formattedDate(row.created_at)} {formattedTime(row.created_at)}</small>
            </div>

            <div className="d-flex align-items-centers fd-col grid-gap-4" style={{ marginTop: 10, marginBottom: 10 }}>
              {className && (
                <span className={`${className} w-100`}>
                  <span></span>{row.status}
                </span>
              )}
            </div>
          </>
        );

      },
      width: "190px",
    },
    {
      name: <span className="cellHeading">Amount</span>,
      selector: (row) => {
        return (
          <div>
            <span className="fw-600 fs-md">{'₹'+row.total}</span> <br />
            <span className="text-neutral-dark-200 fs-xs">
              { row.totalProducts > 1 ? `(${row.totalProducts} Items)` : `(${row.totalProducts} Item)` }
            </span>
          </div>
        )
      },
      width: "120px",
    },
    {
      name: <span className="cellHeading">Mode</span>,
      selector: (row) => {
        const isCOD = row.payment_type === 'COD';
        const remark = row.remark || '';
        
        // Extract amount using RegExp
        const advanceMatch = remark.match(/Received the Advance amount of ₹([\d,]+)/);
        const advanceAmount = advanceMatch ? `₹${advanceMatch[1]}` : null;
    
        return (
          <div className="d-flex align-items-center fd-col grid-gap-4">
            <span className={isCOD ? "codBtn" : "onlineBtn"}>
              <span></span>{isCOD ? "COD" : "Online"}
            </span>
            <span className="fs-xs text-neutral-dark-200">
              Status: {row.payment_status}
            </span>
            {isCOD && advanceAmount && (
              <span className="fs-xs text-success"><strong>Advance: {advanceAmount}/-</strong></span>
            )}
          </div>
        );
      },
      width: "135px",
    },
    {
      name: "Courier",
      selector: (row) => {
        if (row.courier_details && row.courier_details.length > 0) {
          const sortedCourierDetails = [...row.courier_details].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          const latest = sortedCourierDetails[0];
          const tooltipId = `courier-tooltip-${row.id}`;
    
          return (
            <>
              <span
                id={tooltipId}
                // className="courier-tooltip-trigger text-primary underline cursor-pointer"
              >
                {/* <BiDotsVerticalRounded /> */}
                <img src={ BASE_URL + latest.courier.logo} alt="logo" style={{ width: "80px", height: "auto" }} /> <br />
              </span>
              <small><strong>Status:</strong> {latest.courier_status || "Pending"}</small>
    
              <Tooltip
                anchorId={tooltipId}
                place="top"
                className="custom-tooltip"
                clickable
              >
                <div className="tooltip-content">
                  <div>
                    <strong>Tracking No:</strong> {latest.tracking_no || "N/A"}
                  </div>
                  <div>
                    <strong>ETA:</strong> {formattedDate(latest.estimated_delivery_date)}
                  </div>
                  <div>
                    <strong>Status:</strong> {latest.courier_status || "Pending"}
                  </div>
                  {latest.tracking_link && (
                    <div onClick={() => handleCopy(latest.tracking_link)}>
                      
                        Copy link <BiCopy style={{ cursor: "pointer", marginLeft: "8px" }} />
                    </div>
                  )}
                </div>
              </Tooltip>
            </>
          );
        } else {
          return <span className="text-muted">N/A</span>;
        }
      },
      width: "140px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="actionsWrapper">
           {/* <div onClick={() => handleView(row.id, row.po_number)}> */}
           
           {/* <div onClick={() => downloadInvoice(row.id)}>
            <RiDownloadLine />
            <div style={{
              position: "absolute",
              top: 0,
              left: "-9999px",
              width: 800
            }}>
              <HiddenPO
                ref={(el) => (refs.current[row.id] = el)}
                order={row}
              />

            </div>
          </div> */}
          <div onClick={() => handleEdit(row.id, row.po_number)}>
            <RiEdit2Line /> 
          </div>
          <div onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line />
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },    
  ];



  return (
    <div>
      {loader && <p>Loading...</p>}
      {errors && <p style={{ color: "red" }}>Error: {errors}</p>}
      {!loader && !errors && (
        <div className="ContainerBox">
          <CustomDataTable columns={columns} data={orders} title="Orders List" mHeight={100} />
        </div>
      )}
    </div>
  );
};

export default Orders;
